import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Invoice } from '../_models/invoice';
import { environment } from './../../../environments/environment';

@Injectable()
export class InvoiceService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getInvoices(): Observable<Invoice[]> {
    return this.http
      .get<Invoice[]>(this.apiBaseUrl + 'api/private/v1/documentInvoices')
      .pipe(map((response) => response));
  }

  getInvoice(id: number): Observable<Invoice> {
    return this.http
      .get<Invoice>(this.apiBaseUrl + 'api/private/v1/documentInvoices/' + id)
      .pipe(map((response) => response));
  }
}
